export const USER_STREAM_LOAD_REQUEST = 'USER_STREAM_LOAD_REQUEST';
export const USER_STREAM_LOAD_SUCCESS = 'USER_STREAM_LOAD_SUCCESS';
export const USER_STREAM_LOAD_FAILURE = 'USER_STREAM_LOAD_FAILURE';
export const USER_STREAM_UPDATE_SUCCESS = 'USER_STREAM_UPDATE_SUCCESS';
